import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getServerUrl } from '../../Utils/serverSelector';
import { getJwtToken } from '../../Utils/authStorage';
import { apiRequest } from '../../Utils/apiClient';

const ALLOWED_TOKEN = process.env.REACT_APP_ALLOWED_TOKEN;

// ================== Thunks ==================

export const uploadUserPhoto = createAsyncThunk(
  'photo/uploadUserPhoto',
  async ({ uid, formData }, { rejectWithValue }) => {
    try {
      if (!uid) throw new Error('UID не передан');
      if (!formData) throw new Error('formData не передан');

      const jwtToken = getJwtToken();
      const authHeader = jwtToken
        ? `Bearer ${jwtToken}`
        : `Bearer ${ALLOWED_TOKEN}`;

      const res = await axios.post(
        `${getServerUrl()}/user-image-upload/${uid}`,
        formData,
        {
          headers: { Authorization: authHeader },
          withCredentials: true,
          validateStatus: () => true,
        }
      );

      if (res.status !== 200 && res.status !== 201) {
        throw new Error(`Ошибка сервера: ${res.status}`);
      }

      return res.data.filePath || '';
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserPhoto = createAsyncThunk(
  'photo/fetchUserPhoto',
  async (uid, { rejectWithValue }) => {
    try {
      if (!uid) return null;
      const res = await apiRequest('GET', `/user-image-upload/${uid}`);
      return res?.data?.filePath || res?.filePath || null;
    } catch (error) {
      if (error.message?.includes('404') || error.message?.includes('403')) {
        return null;
      }
      return rejectWithValue(error.message);
    }
  }
);

// ================== Slice ==================

const initialState = {
  photoPath: '',
  photoVersion: Date.now(), // ✅ инкрементируется при upload — для cache busting в хедере
  status: 'idle',
  error: null,
};

const photoSlice = createSlice({
  name: 'photo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadUserPhoto.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(uploadUserPhoto.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.photoPath = action.payload || '';
        state.photoVersion = Date.now(); // ✅ обновляем версию — хедер перезагрузит картинку
      })
      .addCase(uploadUserPhoto.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error?.message;
      })

      .addCase(fetchUserPhoto.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
     .addCase(fetchUserPhoto.fulfilled, (state, action) => {
  state.status = 'succeeded';
  state.photoPath = action.payload || '';
  state.photoVersion = Date.now(); // ← добавить
})
      .addCase(fetchUserPhoto.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error?.message;
      });
  },
});

export default photoSlice.reducer;